<template>
  <account-tree v-if="valueName == 'account_tree'" />
  <adb v-else-if="valueName == 'adb'" />
  <airline-seat-flat v-else-if="valueName == 'airline_seat_flat'" />
  <airline-seat-flat-angled
    v-else-if="valueName == 'airline_seat_flat_angled'"
  />
  <airline-seat-individual-suite
    v-else-if="valueName == 'airline_seat_individual_suite'"
  />
  <airline-seat-legroom-extra
    v-else-if="valueName == 'airline_seat_legroom_extra'"
  />
  <airline-seat-legroom-normal
    v-else-if="valueName == 'airline_seat_legroom_normal'"
  />
  <airline-seat-legroom-reduced
    v-else-if="valueName == 'airline_seat_legroom_reduced'"
  />
  <airline-seat-recline-extra
    v-else-if="valueName == 'airline_seat_recline_extra'"
  />
  <airline-seat-recline-normal
    v-else-if="valueName == 'airline_seat_recline_normal'"
  />
  <bluetooth-audio v-else-if="valueName == 'bluetooth_audio'" />
  <confirmation-number v-else-if="valueName == 'confirmation_number'" />
  <directions-off v-else-if="valueName == 'directions_off'" />
  <disc-full v-else-if="valueName == 'disc_full'" />
  <do-disturb v-else-if="valueName == 'do_disturb'" />
  <do-disturb-alt v-else-if="valueName == 'do_disturb_alt'" />
  <do-disturb-off v-else-if="valueName == 'do_disturb_off'" />
  <do-disturb-on v-else-if="valueName == 'do_disturb_on'" />
  <drive-eta v-else-if="valueName == 'drive_eta'" />
  <enhanced-encryption v-else-if="valueName == 'enhanced_encryption'" />
  <event-available v-else-if="valueName == 'event_available'" />
  <event-busy v-else-if="valueName == 'event_busy'" />
  <event-note v-else-if="valueName == 'event_note'" />
  <folder-special v-else-if="valueName == 'folder_special'" />
  <live-tv v-else-if="valueName == 'live_tv'" />
  <mms v-else-if="valueName == 'mms'" />
  <more v-else-if="valueName == 'more'" />
  <network-check v-else-if="valueName == 'network_check'" />
  <network-locked v-else-if="valueName == 'network_locked'" />
  <no-encryption v-else-if="valueName == 'no_encryption'" />
  <no-encryption-gmailerrorred
    v-else-if="valueName == 'no_encryption_gmailerrorred'"
  />
  <ondemand-video v-else-if="valueName == 'ondemand_video'" />
  <personal-video v-else-if="valueName == 'personal_video'" />
  <phone-bluetooth-speaker v-else-if="valueName == 'phone_bluetooth_speaker'" />
  <phone-callback v-else-if="valueName == 'phone_callback'" />
  <phone-forwarded v-else-if="valueName == 'phone_forwarded'" />
  <phone-in-talk v-else-if="valueName == 'phone_in_talk'" />
  <phone-locked v-else-if="valueName == 'phone_locked'" />
  <phone-missed v-else-if="valueName == 'phone_missed'" />
  <phone-paused v-else-if="valueName == 'phone_paused'" />
  <power v-else-if="valueName == 'power'" />
  <power-off v-else-if="valueName == 'power_off'" />
  <priority-high v-else-if="valueName == 'priority_high'" />
  <sd-card v-else-if="valueName == 'sd_card'" />
  <sd-card-alert v-else-if="valueName == 'sd_card_alert'" />
  <sms v-else-if="valueName == 'sms'" />
  <sms-failed v-else-if="valueName == 'sms_failed'" />
  <support-agent v-else-if="valueName == 'support_agent'" />
  <sync v-else-if="valueName == 'sync'" />
  <sync-disabled v-else-if="valueName == 'sync_disabled'" />
  <sync-problem v-else-if="valueName == 'sync_problem'" />
  <system-update v-else-if="valueName == 'system_update'" />
  <tap-and-play v-else-if="valueName == 'tap_and_play'" />
  <time-to-leave v-else-if="valueName == 'time_to_leave'" />
  <tv-off v-else-if="valueName == 'tv_off'" />
  <vibration v-else-if="valueName == 'vibration'" />
  <voice-chat v-else-if="valueName == 'voice_chat'" />
  <vpn-lock v-else-if="valueName == 'vpn_lock'" />
  <wc v-else-if="valueName == 'wc'" />
  <wifi v-else-if="valueName == 'wifi'" />
  <wifi-off v-else-if="valueName == 'wifi_off'" />
</template>

<script>
import AccountTree from "@/components/Icons/Notification/AccountTree";
import Adb from "@/components/Icons/Notification/Adb";
import AirlineSeatFlat from "@/components/Icons/Notification/AirlineSeatFlat";
import AirlineSeatFlatAngled from "@/components/Icons/Notification/AirlineSeatFlatAngled";
import AirlineSeatIndividualSuite from "@/components/Icons/Notification/AirlineSeatIndividualSuite";
import AirlineSeatLegroomExtra from "@/components/Icons/Notification/AirlineSeatLegroomExtra";
import AirlineSeatLegroomNormal from "@/components/Icons/Notification/AirlineSeatLegroomNormal";
import AirlineSeatLegroomReduced from "@/components/Icons/Notification/AirlineSeatLegroomReduced";
import AirlineSeatReclineExtra from "@/components/Icons/Notification/AirlineSeatReclineExtra";
import AirlineSeatReclineNormal from "@/components/Icons/Notification/AirlineSeatReclineNormal";
import BluetoothAudio from "@/components/Icons/Notification/BluetoothAudio";
import ConfirmationNumber from "@/components/Icons/Notification/ConfirmationNumber";
import DirectionsOff from "@/components/Icons/Notification/DirectionsOff";
import DiscFull from "@/components/Icons/Notification/DiscFull";
import DoDisturb from "@/components/Icons/Notification/DoDisturb";
import DoDisturbAlt from "@/components/Icons/Notification/DoDisturbAlt";
import DoDisturbOff from "@/components/Icons/Notification/DoDisturbOff";
import DoDisturbOn from "@/components/Icons/Notification/DoDisturbOn";
import DriveEta from "@/components/Icons/Notification/DriveEta";
import EnhancedEncryption from "@/components/Icons/Notification/EnhancedEncryption";
import EventAvailable from "@/components/Icons/Notification/EventAvailable";
import EventBusy from "@/components/Icons/Notification/EventBusy";
import EventNote from "@/components/Icons/Notification/EventNote";
import FolderSpecial from "@/components/Icons/Notification/FolderSpecial";
import LiveTv from "@/components/Icons/Notification/LiveTv";
import Mms from "@/components/Icons/Notification/Mms";
import More from "@/components/Icons/Notification/More";
import NetworkCheck from "@/components/Icons/Notification/NetworkCheck";
import NetworkLocked from "@/components/Icons/Notification/NetworkLocked";
import NoEncryption from "@/components/Icons/Notification/NoEncryption";
import NoEncryptionGmailerrorred from "@/components/Icons/Notification/NoEncryptionGmailerrorred";
import OndemandVideo from "@/components/Icons/Notification/OndemandVideo";
import PersonalVideo from "@/components/Icons/Notification/PersonalVideo";
import PhoneBluetoothSpeaker from "@/components/Icons/Notification/PhoneBluetoothSpeaker";
import PhoneCallback from "@/components/Icons/Notification/PhoneCallback";
import PhoneForwarded from "@/components/Icons/Notification/PhoneForwarded";
import PhoneInTalk from "@/components/Icons/Notification/PhoneInTalk";
import PhoneLocked from "@/components/Icons/Notification/PhoneLocked";
import PhoneMissed from "@/components/Icons/Notification/PhoneMissed";
import PhonePaused from "@/components/Icons/Notification/PhonePaused";
import Power from "@/components/Icons/Notification/Power";
import PowerOff from "@/components/Icons/Notification/PowerOff";
import PriorityHigh from "@/components/Icons/Notification/PriorityHigh";
import SdCard from "@/components/Icons/Notification/SdCard";
import SdCardAlert from "@/components/Icons/Notification/SdCardAlert";
import Sms from "@/components/Icons/Notification/Sms";
import SmsFailed from "@/components/Icons/Notification/SmsFailed";
import SupportAgent from "@/components/Icons/Notification/SupportAgent";
import Sync from "@/components/Icons/Notification/Sync";
import SyncDisabled from "@/components/Icons/Notification/SyncDisabled";
import SyncProblem from "@/components/Icons/Notification/SyncProblem";
import SystemUpdate from "@/components/Icons/Notification/SystemUpdate";
import TapAndPlay from "@/components/Icons/Notification/TapAndPlay";
import TimeToLeave from "@/components/Icons/Notification/TimeToLeave";
import TvOff from "@/components/Icons/Notification/TvOff";
import Vibration from "@/components/Icons/Notification/Vibration";
import VoiceChat from "@/components/Icons/Notification/VoiceChat";
import VpnLock from "@/components/Icons/Notification/VpnLock";
import Wc from "@/components/Icons/Notification/Wc";
import Wifi from "@/components/Icons/Notification/Wifi";
import WifiOff from "@/components/Icons/Notification/WifiOff";

export default {
  components: {
    AccountTree,
    Adb,
    AirlineSeatFlat,
    AirlineSeatFlatAngled,
    AirlineSeatIndividualSuite,
    AirlineSeatLegroomExtra,
    AirlineSeatLegroomNormal,
    AirlineSeatLegroomReduced,
    AirlineSeatReclineExtra,
    AirlineSeatReclineNormal,
    BluetoothAudio,
    ConfirmationNumber,
    DirectionsOff,
    DiscFull,
    DoDisturb,
    DoDisturbAlt,
    DoDisturbOff,
    DoDisturbOn,
    DriveEta,
    EnhancedEncryption,
    EventAvailable,
    EventBusy,
    EventNote,
    FolderSpecial,
    LiveTv,
    Mms,
    More,
    NetworkCheck,
    NetworkLocked,
    NoEncryption,
    NoEncryptionGmailerrorred,
    OndemandVideo,
    PersonalVideo,
    PhoneBluetoothSpeaker,
    PhoneCallback,
    PhoneForwarded,
    PhoneInTalk,
    PhoneLocked,
    PhoneMissed,
    PhonePaused,
    Power,
    PowerOff,
    PriorityHigh,
    SdCard,
    SdCardAlert,
    Sms,
    SmsFailed,
    SupportAgent,
    Sync,
    SyncDisabled,
    SyncProblem,
    SystemUpdate,
    TapAndPlay,
    TimeToLeave,
    TvOff,
    Vibration,
    VoiceChat,
    VpnLock,
    Wc,
    Wifi,
    WifiOff,
  },
  props: {
    valueName: {
      type: [String],
    },
  },
};
</script>
